export default __webpack_public_path__ + "static/generative-stative-compound-transitive-b803e21da92d061d22f4e5faed98ab60.svg";